import React, { Component } from 'react'
import { connect } from 'react-redux'
import PropTypes from 'prop-types'
import CalendarCheckIcon from '../assets/CalendarCheckIcon'
import CircleChart from './CircleChart'
import DeliveredIcon from '../assets/DeliveredIcon'
import fetchApi from '../../services/fetchApi'
import LoadingSpinner from '../sitewide/Spinner'
import MessagesBox from './MessagesBox'
import ScheduleBox from '../sitewide/ScheduleBox'
import AllLocationsCheckbox from '../sitewide/Filter/AllLocationsCheckbox'
import css from './styles.css'

const iconStyles = {
  dimensions: {
    width: '70%',
    height: 'auto',
  },
  fill: '#555555',
}

const chartSizes = {
  height: 250,
  width: 250,
  innerRadius: 70,
  outerRadius: 80,
}

const countMessagesByStatus = (counts) => {
  const allCounts = {
    totalReminders: 0,
    totalRemindersDelivered: 0,
    totalRemindersUndelivered: 0,
    texts: {
      numRemindersDelivered: 0,
      numRemindersSent: 0,
      numRemindersUndelivered: 0,
    },
    emails: {
      numRemindersDelivered: 0,
      numRemindersSent: 0,
      numRemindersUndelivered: 0,
    },
  }

  const successStatusesByType = {
    texts: ['delivered', 'read'],
    emails: ['delivered', 'read', 'sent'],
  }

  Object.keys(counts).forEach((type) => {
    delete counts[type].draft
    Object.keys(counts[type]).forEach((status) => {
      const val = counts[type][status]
      if (successStatusesByType[type].includes(status)) {
        allCounts[type].numRemindersDelivered += val
        allCounts.totalRemindersDelivered += val
      } else {
        allCounts.totalRemindersUndelivered += val
        allCounts[type].numRemindersUndelivered += val
      }
      allCounts[type].numRemindersSent += val
      allCounts.totalReminders += val
    })
  })

  return allCounts
}

class Reminders extends Component {
  constructor(props) {
    super(props)

    this.state = {
      isLoaded: false,
      totalReminders: 0,
      totalRemindersUndelivered: 0,
      texts: {
        numRemindersDelivered: 0,
        numRemindersSent: 0,
        numRemindersUndelivered: 0,
      },
      emails: {
        numRemindersDelivered: 0,
        numRemindersSent: 0,
        numRemindersUndelivered: 0,
      },
      numApptConfirmed: 0,
      numApptUnconfirmed: 0,
      appointments: [],
      searchAllLocations: false,
    }
  }

  componentDidMount() {
    this.fetchReminders()
  }

  componentDidUpdate(prevProps) {
    const { activeLocation, hasDSO } = this.props
    if (
      hasDSO &&
      activeLocation &&
      prevProps.activeLocation &&
      prevProps.activeLocation.id !== activeLocation.id
    ) {
      this.fetchReminders()
    }
  }

  setUrlForFetch = () => {
    const { activeLocation, hasDSO } = this.props
    const { searchAllLocations } = this.state

    return hasDSO && activeLocation
      ? `/?location_id=${activeLocation.id}&all_locations=${searchAllLocations}`
      : '/'
  }

  fetchReminders = async () => {
    await fetchApi(this.setUrlForFetch(), 'GET').then(
      ({ appointments, message_counts, appointment_counts }) => {
        const {
          totalReminders,
          texts,
          emails,
          totalRemindersDelivered,
          totalRemindersUndelivered,
        } = countMessagesByStatus(message_counts)
        this.setState({
          isLoaded: true,
          totalReminders,
          totalRemindersDelivered,
          totalRemindersUndelivered,
          texts,
          emails,
          numApptConfirmed: appointment_counts.confirmed,
          numApptUnconfirmed: appointment_counts.unconfirmed,
          appointments,
        })
      },
    )
  }

  handleAllLocationsCheckbox = (e) => {
    e.stopPropagation()
    this.setState({ searchAllLocations: e.target.checked }, this.fetchReminders)
  }

  render() {
    const { hasDSO, userLocations, pmsType } = this.props
    const {
      totalReminders,
      totalRemindersDelivered,
      totalRemindersUndelivered,
      numApptConfirmed,
      numApptUnconfirmed,
      isLoaded,
      appointments,
      texts,
      emails,
      searchAllLocations,
    } = this.state

    const data = {
      messages: [
        { value: totalRemindersDelivered },
        {
          value:
            totalRemindersDelivered === 0 && totalRemindersUndelivered === 0
              ? 1
              : totalRemindersUndelivered,
        },
      ],
      appointments: [
        { value: numApptConfirmed },
        {
          value:
            numApptConfirmed === 0 && numApptUnconfirmed === 0
              ? 1
              : numApptUnconfirmed,
        },
      ],
    }
    const { height, width, innerRadius, outerRadius } = chartSizes

    const showAllLocationsCheckbox = hasDSO && userLocations && userLocations.length > 1

    return (
      <div className={css.container}>
        {!isLoaded ? (
          <LoadingSpinner />
        ) : (
          <div className="Reminders">
            <div className={css.headsUp}>
              <CircleChart
                primaryColor="#6bc14f"
                secondaryColor="#e5ffdd"
                data={data.messages}
                height={height}
                width={width}
                innerRadius={innerRadius}
                outerRadius={outerRadius}
              >
                <DeliveredIcon
                  fill={iconStyles.fill}
                  styles={iconStyles.dimensions}
                />
                <span className={css.label}>
                  <strong>Delivered</strong>
                </span>
              </CircleChart>

              <MessagesBox
                numAppt={appointments.length}
                numApptConfirmed={numApptConfirmed}
                numEmailRemindersSent={emails.numRemindersSent}
                numEmailRemindersDelivered={emails.numRemindersDelivered}
                numTextRemindersSent={texts.numRemindersSent}
                numTextRemindersDelivered={texts.numRemindersDelivered}
                totalReminders={totalReminders}
              />
              <CircleChart
                primaryColor="#2aa6c6"
                secondaryColor="#e2f9ff"
                data={data.appointments}
                height={height}
                width={width}
                innerRadius={innerRadius}
                outerRadius={outerRadius}
              >
                <CalendarCheckIcon
                  fill={iconStyles.fill}
                  styles={iconStyles.dimensions}
                />
                <span className={css.label}>
                  <strong>Confirmed</strong>
                </span>
              </CircleChart>
            </div>
            {showAllLocationsCheckbox && (
              <div className={css.allLocationCheckbox}>
                <AllLocationsCheckbox
                  checked={searchAllLocations}
                  handleCheck={this.handleAllLocationsCheckbox}
                />
              </div>
            )}
            <div className={css.ScheduleList}>
              <ScheduleBox
                appointments={appointments}
                pmsType={pmsType}
              />
            </div>
          </div>
        )}
      </div>
    )
  }
}

Reminders.propTypes = {
  activeLocation: PropTypes.shape({
    active: PropTypes.bool.isRequired,
    additional_recipients: PropTypes.arrayOf(PropTypes.object),
    city: PropTypes.string,
    country_code: PropTypes.string,
    created_at: PropTypes.string,
    doctor_id: PropTypes.string,
    earliest_same_day_reminder_hour: PropTypes.number,
    facebook_url: PropTypes.string,
    forwarding_email: PropTypes.string,
    google_url: PropTypes.string,
    id: PropTypes.string,
    latitude: PropTypes.number,
    longitude: PropTypes.number,
    name: PropTypes.string,
    office_email: PropTypes.string,
    office_phone: PropTypes.string,
    phone_numbers: PropTypes.arrayOf(PropTypes.object),
    practice_id: PropTypes.number,
    state: PropTypes.string,
    street_address: PropTypes.string,
    timezone: PropTypes.string,
    updated_at: PropTypes.string,
    website: PropTypes.string,
    yelp_url: PropTypes.string,
    zip: PropTypes.string,
  }),
  hasDSO: PropTypes.bool.isRequired,
  userLocations: PropTypes.arrayOf(PropTypes.object),
  pmsType: PropTypes.string,
}

const mapStateToProps = ({
  account: {
    auth: { hasDSO, pmsType },
    user: { activeLocation, locations: userLocations },
  },
}) => ({
  activeLocation,
  hasDSO,
  pmsType,
  userLocations,
})

export default connect(mapStateToProps, null)(Reminders)



// WEBPACK FOOTER //
// ./src/components/Dashboard/Reminders.js